// Global entrypoint: Turbo drives the server-rendered pages (calendar, library).
import '@hotwired/turbo-rails'

// Two-step confirm for server-rendered destructive buttons: first click arms
// the button ("Sure?"), second click within 3s submits. Replaces native
// confirm() dialogs, which browsers can silently suppress.
document.addEventListener('click', (e) => {
  const btn = (e.target as HTMLElement).closest<HTMLButtonElement>('button[data-two-step]')
  if (!btn) return
  if (btn.dataset.armed === 'true') return // second click — let the form submit

  e.preventDefault()
  btn.dataset.armed = 'true'
  btn.dataset.label = btn.textContent ?? ''
  btn.textContent = 'Sure?'
  btn.classList.add('confirm-armed')
  setTimeout(() => {
    if (btn.dataset.armed !== 'true') return
    btn.dataset.armed = 'false'
    btn.textContent = btn.dataset.label ?? ''
    btn.classList.remove('confirm-armed')
  }, 3000)
})
